import {
  React,
  Component,
  withRouter,
} from 'imports/CommonImports';


const styles = {
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}

class PostulationThanksView extends Component {

  render() {
    return (
      <div style={styles.pageContainer}>
        <h1>Gracias por postular el proyecto! Si queda seleccionado se te dará aviso</h1>
      </div>
    );
  }
}

export default withRouter(PostulationThanksView);



// WEBPACK FOOTER //
// ./src/views/postulation/PostulationThanksView.js